<template>
    <Dropdown 
        :id="id"
        v-model="dropdownValue"
        :options="dropdownOptions"
        optionLabel="name"
        @change="onChanged"
        :filter="filter"
        :showClear="showClear"
    >
        <template #value="slotProps">
            <slot
                name="value"
                v-bind:value="slotProps.value"
            />
        </template>
        <template #option="slotProps">
            <slot
                name="option"
                v-bind:option="slotProps.option"
            />
        </template>
    </Dropdown>
</template>

<script>
import Dropdown from 'primevue/dropdown'
import { reactive, ref, computed, toRefs, watch } from 'vue'
import { useI18n } from 'vue-i18n'

export default {
    emits: ['update:modelValue'],
    props: {
        id: {
            type: String,
            required: true
        },
        modelValue: {
            required: true
        },
        mode: {
            type: String,
            required: false,
            default: 'default'
        },
        options: {
            type: Array,
            required: false,
            default: []
        },
        optionValue: {
            type: String,
            required: false,
            default: ''
        },
        showClear: {
            type: Boolean,
            required: false,
            default: true
        },
    },
    setup(props, { emit }) {
        const { modelValue, options, optionValue } = toRefs(props)
        const { t } = useI18n()

        let dropdown = reactive({
            dropdownOptions: options,
            filter: true,
            showClear: props.showClear,
            optionVal: optionValue
        })

        if (props.mode === 'bool') {
            dropdown = reactive({
                dropdownOptions: [
                    { id: true, name: t('labels.yes') },
                    { id: false, name: t('labels.no') }
                ],
                filter: false,
                showClear: false,
                optionVal: 'id'
            })
        }

        const dropdownValue = ref(null)

        const onChanged = (e) => {
            if (!dropdown.optionVal.length) return emit('update:modelValue', e.value)

            const value = e.value ? e.value[dropdown.optionVal] : ''
            emit('update:modelValue', value)
        }

        const setDropdownValue = () => {
            if (modelValue.value === null) return null
            
            if (dropdown.optionVal.length) {                
                const value = typeof modelValue.value === 'object' ? modelValue.value[dropdown.optionVal] : modelValue.value
                dropdownValue.value = dropdown.dropdownOptions.find(o => o[dropdown.optionVal] === value)
            } else { 
                dropdownValue.value = modelValue.value
            }
        }
        
        setDropdownValue()
        watch(modelValue, () => setDropdownValue())

        return {
            ...toRefs(dropdown),
            dropdownValue,
            onChanged
        }
    }
}
</script>